import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import StoreCta from '../components/StoreCta';

export default function About() {
  const { t } = useLanguage();
  const features = t('about.featuresList');
  const tags = t('about.tags');

  return (
    <div className="grid two-col">
      <div className="card">
        <h2 className="section-title">{t('about.title')}</h2>
        <p className="section-subtitle">{t('about.body')}</p>
        <div style={{ marginTop: 24, display: 'grid', gap: 14 }}>
          <div className="card" style={{ background: 'rgba(15,23,42,0.7)' }}>
            <h4 style={{ margin: '0 0 6px' }}>{t('about.mission')}</h4>
            <p className="section-subtitle">{t('about.missionText')}</p>
          </div>
          <div className="card" style={{ background: 'rgba(15,23,42,0.7)' }}>
            <h4 style={{ margin: '0 0 6px' }}>{t('about.vision')}</h4>
            <p className="section-subtitle">{t('about.visionText')}</p>
          </div>
        </div>
      </div>

      <div className="card">
        <h3 className="section-title">{t('about.features')}</h3>
        <ul className="section-subtitle" style={{ paddingLeft: 18, lineHeight: 1.8 }}>
          {(Array.isArray(features) ? features : []).map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
        <div style={{ marginTop: 22, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          {(Array.isArray(tags) ? tags : []).map((tag) => (
            <span className="tag" key={tag}>
              {tag}
            </span>
          ))}
        </div>
      </div>

      <StoreCta style={{ gridColumn: '1 / -1' }} />
    </div>
  );
}
